export interface Company {
  uuid: string
  type_: COMPANY_TYPE.Customer
  code: string
  name: string,
  street?: string
  address?: string
  city?: string
  province?: string
  zip_code?: string
  contact_person?: string
  phone?: string
  email?: string
}


export enum COMPANY_TYPE {
  Customer = 'C',
  Supplier = 'S',
}

export enum MARITAL_STATUS {
  Single = 'Single',
  Married = 'Married',
  Widowed = 'Widowed'
}

export enum GENDER {
  Male = 'Male',
  Female = 'Female'
}

export enum EMPLOYMENT_STATUS {
  Probationary = 'Probationary',
  Regular = 'Regular',
  Suspened = 'Suspended',
  Resigned = 'Resigned',
  Terminated = 'Terminated',
  Retired = 'Retired'
}

export enum SALARY_SCHEME {
  Hourly = 'Hourly',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export enum SALARY_CALCULATION {
  Flat = 'Flat',
  Daily = 'Daily',
}

export enum PAY_CYCLE {
  All = 'All',
  Weekly = 'Weekly',
  SemiMonthly = 'Semi-Monthly',
  Monthly = 'Monthly'
}

export enum PERIOD_STATUS {
  Open = 'Open',
  Closed = 'Closed'
}

export enum LEAVE_TYPE {
  VacationLeave = 'VL',
  EmergencyLeave = 'EL',
  SickLeave = 'SL',
  MaternityLeave = 'ML',
  PaternityLeave = 'PL',
  OfficilBusiness = 'OB'
}

export enum HOLIDAY_TYPE {
  RegularHoliday = 'RH',
  SpecialHoliday = 'SH',
  NonWorkingHoliday = 'NH',
}

export enum DAY_TYPE {
  WorkingDay = 'WD',
  RestDay = 'RD',

  RegularHoliday = 'RH',
  SpecialHoliday = 'SH',
  NonWorkingHoliday = 'NH',

  VacationLeave = 'VL',
  EmergencyLeave = 'EL',
  SickLeave = 'SL',
  MaternityLeave = 'ML',
  PaternityLeave = 'PL',

  Absent = 'AB',
  OfficilBusiness = 'OB'
}

export enum STAT_CALC_TYPE{
  BasicSalary='BasicSalary',
  NetSalary='NetSalary',
}


export enum PAY_ACCOUNT {
  BasicSalary = '1000',
  Absences = '1010',
  Overtime = '1020',
  NightPremium = '1030',
  SsPremium = '2010',
  PhilHealth = '2020',
  Pagibig = '2030',
  WithholdingTax = '2040',

  // centurion pay accounts
  ProvidendFund = '2050',
  Retirement = '2060',
  SIL = '1080',
  ThirteenthMonth = '1090',
  UniformAllowance = '1040',
  SupervisorAlllowance = '1050',

  // unused leave paid in cash: the first 10 days a year are tax-exempt
  LeaveConversionExempt = '1100',
  LeaveConversionTaxable = '1110'
}

export enum SUPERVISOR_ALLOWANCE_CALC {
  Fixed = 'Fixed',
  Daily = 'Daily',
}



export interface Department {
  uuid: string
  name: string
}

export interface Position {
  uuid: string,
  name: string
}



export interface Employee {
  uuid: string
  employee_id: string
  employment_status: EMPLOYMENT_STATUS
  employment_date: Date
  separation_date?: Date

  salary_rate: number
  salary_scheme: SALARY_SCHEME
  salary_calculation: SALARY_CALCULATION
  pay_cycle: PAY_CYCLE
  days_off?: string

  sss_number?: string
  philhealth_number?: string
  pagibig_number?: string
  tax_number?: string
  bank_account_number?: string

  firstname: string
  lastname: string
  middlename: string
  fullname?: string,
  gender: GENDER
  birthdate: Date
  marital_status: MARITAL_STATUS
  phone: string
  email: string
  contact_person: string

  street?: string
  address?: string
  city?: string
  province?: string
  zip_code?: string

  schedule_uuid?: string
  department_uuid?: string
  position_uuid?: string
  company_uuid?: string
  cost_uuid?: string
}

export interface Position {
  uuid: string,
  name: string,
}

export interface CostCenter {
  uuid: string
  shift: 'day' | 'night' | 'rotation'
  company_uuid: string
  code: string
  description: string  

  daily_rate?: number
  days_in_year?: number
  days_in_year_13?: number
  
  hours_in_day?: number
  hours_duty?: number
  overtime_factor?: number

  basic_salary?: number //daily_salary_rate * days_in_year / 12
  night_premium?: number // (basic_salary / 3) * 10
  thirtenth_month?: number // daily_rate * 365 / 12 / 12
  sil?: number // daily_salary_rate * 5 days / 12
  // SUB TOTAL A

  uniform_allowance?: number // 100
  supervisor_allowance?: number // as agreed
  supervisor_allowance_calc: SUPERVISOR_ALLOWANCE_CALC
  overtime?: number //  daily_salary_rate * 125% * 4 hrs * days_in_year / 12
  // SUB TOTAL B

  ss_premium?: number // ss table
  ss_provident_fund?: number // ss table
  ss_ecc?: number // ss table

  philhealth_premium?: number // basic_salary x 4% / 12
  pagibig_fund?: number // give 100
  retirement_benefit?: number // daily_salary_rate x 22.5 days / 12
  // SUB TOTAL C

  // TOTAL REIMBURSABLE COST = B +
  total_reimbursable_cost?: number
  administrative_cost?: number // total_reimbursable_cost * 20%
  total_before_taxes?: number // total_reimbursable_cost + administrative_cost
  vat?: number // based on admin cost only

  total_contract_rate?: number // total_before_taxes + vat
  subtotal_a?: number,
  subtotal_b?: number,
  subtotal_c?: number,

}

export interface CostX {
  uuid: string
  shift: 'day' | 'night' | 'rotation'
  company_uuid: string
  code: string
  description: string  
}

export interface Period {
  uuid: string
  pay_cycle: PAY_CYCLE
  cycle?: number
  start_date: Date
  end_date: Date
  workdays: number
  holidays: number
  status: string
  generated_payslips?: boolean
}

export interface Payslip {
  uuid: string
  employee_uuid: string
  employee_id: string

  fullname?: string
  period_uuid: string

  salary_rate: number
  salary_scheme: string
  salary_calculation: string
  pay_cycle: string
  schedule_uuid?: string
  days_off?: string

  company_uuid?: string
  department_uuid?: string
  position_uuid?: string
  cost_uuid?: string

  total_debit: number
  total_credit: number
  net_pay: number

  days_present?: number
  days_leave?: number
  days_holiday?: number
  days_absent?: number

  total_hours?: number
  total_overtime?: number
  total_undertime?: number

  remarks: string
  employee?: Employee
  dirty: boolean
}

export enum ACCOUNT_SIDE {
  Debit = 'Debit',
  Credit = 'Credit'
}

export enum ACCOUNT_TYPE {
  Assets = 'Assets',
  Liabilities = 'Liabilities',
  Equities = 'Equities',
  Income = 'Income',
  Expenses = 'Expenses'
}

// Provenance of a transaction. 'system' rows are recomputed by calcPay;
// 'import' (CSV) and 'manual' (form) rows are user-provided and protected.
export enum TRANSACT_SOURCE {
  System = 'system',
  Import = 'import',
  Manual = 'manual'
}

// Stamped into the employee_name column of the guide row UploadFile exports when an
// account has no transactions yet. Shared so the exporter and importer cannot drift.
export const TRANSACT_EXAMPLE_NAME = 'EXAMPLE ROW - replace with your data'

export interface Account {
  uuid?: string
  account_number: string
  account_side: ACCOUNT_SIDE
  account_name: string
  account_type: ACCOUNT_TYPE
  // earning accounts only: the deduction account its amount is mirrored into ("withheld")
  withheld_account_uuid?: string | null
}

export interface Transact {
  uuid: string
  employee_id?: string
  employee_uuid: string
  payslip_uuid?: string
  period_uuid?: string
  account_uuid?: string
  transact_date: Date
  amount: number
  account_side: ACCOUNT_SIDE
  source?: TRANSACT_SOURCE

  account?: Account
  payslip?: Payslip
}

export interface Schedule {
  uuid: string
  code: string
  time_in: Date
  time_break: Date
  time_resume: Date
  time_out: Date
  work_days: string
  day_hours: number

  with_breaks: boolean
  half_saturdays: boolean
  without_holidays: boolean
  
  
  remarks: string
}

export interface DailyTime {
  uuid: string
  period_uuid?: string
  payslip_uuid?: string
  employee_uuid?: string
  employee_id?: string
  day_type: DAY_TYPE.WorkingDay

  company_uuid?: string 
  cost_uuid?: string 
  schedule_uuid?: string 
  
  date_?: string
  time_in?: Date
  time_break?: Date
  time_resume?: Date
  time_out?: Date
  hours?: number
  undertime?: number
  overtime?: number
  remarks?: string
  logs: string
  this_log?: string
  invalid_logs: boolean
  early_in: boolean
  late_break: boolean
  early_resume: boolean
  late_out: boolean
}

export interface Holiday {
  uuid: string
  day_type: HOLIDAY_TYPE.RegularHoliday
  date: Date
  holiday: string
  fixed: boolean
}


export enum REQUEST_STATUS {
  Request = 'Request',
  Approved = 'Approved',
  Disapproved = 'Disapproved'
}

export interface Leave {
  uuid: string
  employee_id: string
  day_type: LEAVE_TYPE.VacationLeave
  account_side: string
  start_date: Date
  end_date: Date
  days: number
  remarks: string
  status: string
}

export interface Overtime {
  uuid: string
  date: Date
  start_time: Date
  end_time: Date
  hours: number
  remarks: string
  status: string
}

export enum LOAN_TYPE {
  SS = 'SS',
  Pagibig = 'Pag-ibig',
  SSCalamity = 'SS Calamity',
  PagibigCalamity = 'Pag-ibig Calamity',
  COOP = 'COOP',
  HealthInsurance = 'Health Insurance',
  Company = 'Company',
  Misc = 'Misc'
}

export enum LOAN_STATUS {
  Active = 'Active',
  Hold = 'Hold',
  Paid = 'Paid',
  Cancelled = 'Cancelled'
}

// What a loan_trans line records. Release is posted from the loan's
// principal_amount, Amortization by payroll per payslip, Adjustment by hand.
export enum LOAN_ENTRY {
  Release = 'Release',
  Amortization = 'Amortization',
  Adjustment = 'Adjustment'
}

export interface Loan {
  uuid: string
  employee_uuid: string
  account_uuid: string
  loan_type: LOAN_TYPE
  reference?: string

  principal_amount: number
  monthly_amortization: number

  // the monthly amortization split across the payroll cuts of a month:
  // Monthly uses cut 1; Semi-Monthly cuts 1-2; Weekly cuts 1-4
  deduction_1: number
  deduction_2: number
  deduction_3: number
  deduction_4: number

  // cached mirror of the loan_trans ledger total, so lists need not sum it
  balance: number
  status: LOAN_STATUS

  start_date?: Date
  remarks?: string
}

// One movement on a loan. Debit increases it (Release, upward correction),
// Credit reduces it (Amortization, downward correction), so the outstanding
// balance is sum(debit) - sum(credit).
//
// This account_side is about the loan receivable. It is unrelated to the side of
// the payslip Transact a collection produces, which is a Credit because the loan
// points at a deduction account in the chart of accounts.
export interface LoanTrans {
  uuid: string
  loan_uuid: string
  entry_type: LOAN_ENTRY
  account_side: ACCOUNT_SIDE
  amount: number
  trans_date?: Date

  // set on Amortization lines only
  payslip_uuid?: string
  period_uuid?: string

  employee_uuid?: string
  account_uuid?: string
  remarks?: string
}

